// https://app.growthbook.io/features/mccerts-280_v1
export const MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG = 'mccerts-280_v1'
